import { Spinner } from '@yaradigitallabs/ahua-react';
import logo from '@/assets/logo.svg';

const Loader = () => {
  return (
    <div className="flex flex-col justify-center items-center h-screen w-screen gap-4">
      <img src={logo} alt="Yara Logo" className="h-24 w-24" />
      <Spinner size="x8" />
    </div>
  );
};

export default Loader;
